import * as About from './about.md'
import * as InVision from './invision.md'
import * as ReadingList from './reading-list.md'

export {
  About,
  InVision,
  ReadingList
}